const ERROR_CODE_PATTERN = /\{([^}]+)\}\s*/g;

export const extractErrorCodes = (message = '') =>
  [...message.matchAll(ERROR_CODE_PATTERN)].map((match) => match[1]);

export const stripErrorCodes = (message = '') => message.replace(ERROR_CODE_PATTERN, '').trim();
